import API_BASE_URL from '../config/apiConfig';
import createApiClient from '../config/apiClient';

const apiClient = createApiClient(API_BASE_URL);

export const submitContact = async (data: {
  name: string;
  email: string;
  phone?: string;
  serviceSlug?: string;
  serviceName?: string;
  message: string;
  website?: string; // honeypot
}) => {
  const res = await fetch(`${API_BASE_URL}/contacts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  });
  const json = await res.json();
  if (!res.ok) {
    throw new Error(json.errorMessage || json.message || 'Có lỗi xảy ra');
  }
  return json;
};

export const getContacts = async (params?: { page?: number; limit?: number; status?: string; search?: string }) => {
  const res = await apiClient.get('/contacts', { params });
  const body = res.data;
  return (body?.data ?? body) as { contacts: any[]; total: number; stats: any; totalPages?: number; page?: number };
};

export const updateContact = async (
  id: string,
  data: { status?: string; priority?: string; adminNotes?: string }
) => {
  const res = await apiClient.put(`/contacts/${id}`, data);
  return res.data;
};

export const deleteContact = async (id: string) => {
  const res = await apiClient.delete(`/contacts/${id}`);
  return res.data;
};
